import { render, staticRenderFns } from "./HomeItem.vue?vue&type=template&id=2cccd321&scoped=true&"
import script from "./HomeItem.vue?vue&type=script&lang=js&"
export * from "./HomeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccd321",
  null
  
)

export default component.exports